import React from 'react';
import './Loading.scss';

const Loading = () => (
  <div className="loading-wrapper">
    <div className="loading">
      <div />
      <div />
    </div>
    <div>Loading...</div>
  </div>
);

export default Loading;
